import * as React from 'react';

function SvgDateIcon(props) {
  return (
    <svg
      width={28}
      height={28}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect opacity={0.15} width={28} height={28} rx={3} fill="#ECA8AF" />
      <g clipPath="url(#date-icon_svg__clip0)" fill="#232340">
        <path d="M11.375 13.125h-.583a.583.583 0 100 1.167h.583a.583.583 0 000-1.167zM14.292 13.125h-.584a.583.583 0 000 1.167h.584a.583.583 0 000-1.167zM17.208 13.125h-.583a.583.583 0 000 1.167h.583a.583.583 0 100-1.167zM11.375 15.459h-.583a.583.583 0 100 1.166h.583a.583.583 0 000-1.166zM14.292 15.459h-.584a.583.583 0 000 1.166h.584a.583.583 0 000-1.166zM17.208 15.459h-.583a.583.583 0 000 1.166h.583a.583.583 0 100-1.166zM11.375 17.791h-.583a.583.583 0 100 1.167h.583a.583.583 0 000-1.166zM14.292 17.791h-.584a.583.583 0 000 1.167h.584a.583.583 0 000-1.166zM17.208 17.791h-.583a.583.583 0 000 1.167h.583a.583.583 0 100-1.166z" />
        <path d="M19.541 8.75h-1.604a.146.146 0 01-.146-.146v-1.02a.584.584 0 00-1.166 0v2.77a.437.437 0 01-.875 0V9.042a.292.292 0 00-.292-.292h-3.646a.146.146 0 01-.146-.145V7.583a.583.583 0 00-1.166 0v2.771a.437.437 0 01-.875 0V9.042a.292.292 0 00-.292-.292h-.875a1.167 1.167 0 00-1.167 1.167v9.916A1.167 1.167 0 008.459 21h11.083a1.167 1.167 0 001.167-1.167V9.917a1.167 1.167 0 00-1.166-1.167zm0 10.792a.292.292 0 01-.291.291H8.75a.292.292 0 01-.292-.291v-7a.292.292 0 01.292-.292h10.5a.292.292 0 01.291.292v7z" />
      </g>
      <defs>
        <clipPath id="date-icon_svg__clip0">
          <path fill="#fff" transform="translate(7 7)" d="M0 0h14v14H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgDateIcon;
